import React, { useState } from "react";
import { Modal } from "antd";
import { Select, Space } from "antd";
import { Icon } from "@iconify/react";

const AddEditpatternModal = ({ isaddModalOpen, setisaddModalOpen }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [selectedType, setSelectedType] = useState("");

  const handleTypeChange = (value) => {
    setSelectedType(value);
  };
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const handleOk = () => {
    setisaddModalOpen(false);
  };
  const handleCancel = () => {
    setisaddModalOpen(false);
  };
  return (
    <>
      <div>
        <Modal
          open={isaddModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          className="editpattern-modal"
          centered={true}
          width="70%"
        >
          <div className="modal-content">
            <h2 className="fw-bold text-medium-black text-center mt-5">
              Add / Edit Pattern
            </h2>
            <form>
              <div className="template-div  flex-column mt-5">
                <div className="edit-profile-main d-flex flex-column gap-3">
                  <div className="edit-container d-flex  gap-5 ">
                    <div className="edit-profile-inner d-flex flex-column gap-3">
                      <h5>Select Group</h5>
                      <Space wrap>
                        <Select
                          defaultValue="Group 1"
                          style={{ width: 317 }}
                          options={[
                            { value: "Group 1", label: "Group 1" },
                            { value: "Group 2", label: "Group 2" },
                            { value: "Group 3", label: "Group 3" },
                          ]}
                        />
                      </Space>
                    </div>
                    <div className="d-flex flex-column gap-3">
                      <div className="edit-profile-inner d-flex flex-column gap-3">
                        <h5>Regex Pattern Name</h5>
                        <input
                          type="text"
                          placeholder="Enter regex pattern name...."
                          className="modal-input "
                        ></input>
                      </div>
                      <div className="check-me-div d-flex gap-2">
                        <input
                          type="checkbox"
                          id="customCheckboxSelectAll"
                          style={{ display: "none" }}
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                        />
                        <label
                          htmlFor="customCheckboxSelectAll"
                          className="customCheckboxLabel"
                        >
                          <span
                            className="customCheckboxTick"
                            style={{
                              background: isChecked
                                ? "#435AB8 "
                                : "transparent",
                            }}
                          >
                            {isChecked && (
                              <span>
                                <Icon
                                  icon="tabler:check"
                                  width={20}
                                  height={18}
                                  color="#FFFFFF"
                                />
                              </span>
                            )}
                          </span>
                        </label>
                        <label className="elarge "> Public group</label>
                      </div>
                    </div>
                  </div>
                  <hr></hr>
                  <div className="type-container d-flex flex-column gap-5 mb-3 ">
                    <div className="edit-profile-inner d-flex flex-column gap-3">
                      <h5>Select Type</h5>
                      <Space wrap>
                        <Select
                          defaultValue="Select Type"
                          style={{ width: 507 }}
                          onChange={handleTypeChange}
                          options={[
                            { value: "Numeric", label: "Numeric" },
                            {
                              value: "Upper character",
                              label: "Upper character",
                            },
                            {
                              value: "Lower character",
                              label: "Lower character",
                            },
                            { value: "Mixed", label: "Mixed" },
                            {
                              value: "Special character",
                              label: "Special character",
                            },
                          ]}
                        />
                      </Space>
                    </div>
                    {selectedType === "Numeric" && (
                      <div className="numeric-container d-flex flex-column fit-content">
                        <div className="numeric-top d-flex gap-5">
                          <div className="edit-profile-inner d-flex flex-column gap-2">
                            <h5>Numeric Range</h5>
                            <div className="d-flex flex-column">
                              <input
                                type="number"
                                placeholder="Enter numeric range..."
                                className="modal-input  mt-1"
                              ></input>
                              <label className="small fw-normal text-light-gray mt-2">
                                Example : 0-9 For 0-9 , 1-3 For 1-3
                              </label>
                            </div>
                          </div>
                          <div className="edit-profile-inner d-flex flex-column gap-2">
                            <h5>Minimum Digit(s)</h5>
                            <div className="d-flex flex-column">
                              <input
                                type="number"
                                placeholder="Enter minimum digit(s)..."
                                className="modal-input  mt-1"
                              ></input>
                            </div>
                          </div>
                          <div className="edit-profile-inner d-flex flex-column gap-2">
                            <h5>Maximum Digit(s)</h5>
                            <div className="d-flex flex-column">
                              <input
                                type="number"
                                placeholder="Enter maximum digit(s)..."
                                className="modal-input  mt-1"
                              ></input>
                              <label className="small fw-normal text-light-gray mt-2">
                                Example : If minimum digit 1 & maximum digit 3
                                then it allow 3/33/333.
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="modal-bottom-btns d-flex justify-content-end gap-2">
                          <button className="modal-dark-btn">Add</button>
                          <button className="modal-dark-btn">Reset</button>
                        </div>
                      </div>
                    )}
                    {selectedType === "Upper character" && (
                      <div className="numeric-container d-flex flex-column fit-content">
                        <div className="numeric-top d-flex gap-5">
                          <div className="edit-profile-inner d-flex flex-column gap-2">
                            <h5>Upper First Letter</h5>
                            <div className="d-flex flex-column">
                              <input
                                type="text"
                                placeholder="A"
                                className="modal-input  mt-1"
                              ></input>
                            </div>
                          </div>
                          <div className="edit-profile-inner d-flex flex-column gap-2">
                            <h5>Upper Last Letter</h5>
                            <div className="d-flex flex-column">
                              <input
                                type="text"
                                placeholder="Z"
                                className="modal-input  mt-1"
                              ></input>
                            </div>
                          </div>
                          <div className="edit-profile-inner d-flex flex-column gap-2">
                            <h5>Letter Accept Count</h5>
                            <div className="d-flex flex-column">
                              <input
                                type="number"
                                placeholder="Enter letter count..."
                                className="modal-input  mt-1"
                              ></input>
                              <label className="small fw-normal text-light-gray mt-2">
                                Example : 4 - ABCD , 2 -XZ
                                <br />
                                2, - minimum 2 letter
                                <br />
                                2,4-minimum 2 , max 4
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="modal-bottom-btns d-flex justify-content-end gap-2">
                          <button className="modal-dark-btn">Add</button>
                          <button className="modal-dark-btn">Reset</button>
                        </div>
                      </div>
                    )}
                    {selectedType === "Lower character" && (
                      <div className="numeric-container d-flex flex-column fit-content">
                        <div className="numeric-top d-flex gap-5">
                          <div className="edit-profile-inner d-flex flex-column gap-2">
                            <h5>Lower First Letter</h5>
                            <div className="d-flex flex-column">
                              <input
                                type="text"
                                placeholder="a"
                                className="modal-input  mt-1"
                              ></input>
                            </div>
                          </div>
                          <div className="edit-profile-inner d-flex flex-column gap-2">
                            <h5>Lower Last Letter</h5>
                            <div className="d-flex flex-column">
                              <input
                                type="a"
                                placeholder="Z"
                                className="modal-input  mt-1"
                              ></input>
                            </div>
                          </div>
                          <div className="edit-profile-inner d-flex flex-column gap-2">
                            <h5>Letter Accept Count</h5>
                            <div className="d-flex flex-column">
                              <input
                                type="number"
                                placeholder="Enter letter count..."
                                className="modal-input  mt-1"
                              ></input>
                              <label className="small fw-normal text-light-gray mt-2">
                                Example : 4 - abcd , 2 -xy
                                <br />
                                2, - minimum 2 letter
                                <br />
                                2,4-minimum 2 , max 4
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="modal-bottom-btns d-flex justify-content-end gap-2">
                          <button className="modal-dark-btn">Add</button>
                          <button className="modal-dark-btn">Reset</button>
                        </div>
                      </div>
                    )}
                    {selectedType === "Mixed" && (
                      <div className="numeric-container d-flex flex-column fit-content">
                        <div className="numeric-top d-flex gap-5">
                          <div className="edit-profile-inner d-flex flex-column gap-2">
                            <h5>Mixed</h5>
                            <div className="d-flex flex-column">
                              <input
                                type="text"
                                placeholder="Enter mixed..."
                                className="modal-input  mt-1"
                              ></input>
                              <label className="small fw-normal text-light-gray mt-2">
                                Example : [A-Za-z0-9!_]
                              </label>
                            </div>
                          </div>
                          <div className="edit-profile-inner d-flex flex-column gap-2">
                            <h5>Letter Accept Count</h5>
                            <div className="d-flex flex-column">
                              <input
                                type="number"
                                placeholder="Enter letter count..."
                                className="modal-input  mt-1"
                              ></input>
                              <label className="small fw-normal text-light-gray mt-2">
                                Example : 4 - abcd , 2 -xz , empty/blank Single
                                Pattern
                                <br />
                                2, - minimum 2 letter
                                <br />
                                2,4-minimum 2 , max 4
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="modal-bottom-btns d-flex justify-content-end gap-2">
                          <button className="modal-dark-btn">Add</button>
                          <button className="modal-dark-btn">Reset</button>
                        </div>
                      </div>
                    )}
                    {selectedType === "Special character" && (
                      <div className="numeric-container d-flex flex-column fit-content">
                        <div className="numeric-top d-flex gap-5">
                          <Space wrap>
                            <Select
                              defaultValue="Select Special Character"
                              style={{ width: 507 }}
                              options={[
                                { value: ".", label: "." },
                                { value: ",", label: "," },
                                { value: "!", label: "!" },
                              ]}
                            />
                          </Space>
                        </div>
                        <div className="modal-bottom-btns d-flex justify-content-end gap-2">
                          <button className="modal-dark-btn">Add</button>
                          <button className="modal-dark-btn">Reset</button>
                        </div>
                      </div>
                    )}
                  </div>
                  <hr></hr>
                  <div className="edit-container d-flex  gap-5 ">
                    <div className="edit-profile-inner d-flex flex-column gap-3">
                      <div className="d-flex gap-2">
                        <h5>Regex Pattern </h5>
                        <img src="../../assets/icons/info.svg" alt="info" />
                      </div>

                      <input
                        type="text"
                        placeholder="Enter regex pattern"
                        className="modal-input "
                      ></input>
                    </div>
                  </div>
                </div>
                <div className="modal-btns-outer-div">
                  <div className="modal-bottom-btns h-center gap-2">
                    <button className="modal-dark-btn" onClick={handleCancel}>
                      Close
                    </button>
                    <button className="modal-dark-btn" onClick={handleOk}>
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default AddEditpatternModal;
